import type { ReactNode } from 'react';
import { ForgeSunArt } from './ForgeSunArt';

interface ForgeStageProps {
  /** True before the first message: the Forge has not started anything yet. */
  isInitial: boolean;
  /** True while Domino is answering the last message. */
  working: boolean;
  /** Existing tools and drafts, shown under the art on the initial screen. */
  children?: ReactNode;
}

// Right pane of the Forge while no app is shown yet. The chat stays on the
// left; this pane says where the app will appear.
export const ForgeStage = ({ isInitial, working, children }: ForgeStageProps) => {
  const title = isInitial ? 'Votre app prendra forme ici' : 'La première version s’affichera ici';
  const description = isInitial
    ? 'Décrivez dans le chat le travail à outiller. Domino propose une première version à cet endroit, puis vous l’ajustez ensemble.'
    : working
      ? 'Domino y travaille.'
      : 'Répondez à Domino dans le chat pour la lancer.';

  return (
    <div className="flex min-h-full flex-col items-center px-6 py-10 lg:px-12">
      <div className="flex w-full max-w-xl flex-col items-center text-center lg:mt-[6vh]">
        <ForgeSunArt />
        <h2 className="mt-6 font-display text-2xl font-semibold tracking-tight text-domino-ink">
          {title}
        </h2>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-domino-inkSoft">{description}</p>
      </div>
      {children ? <div className="mt-12 w-full max-w-2xl">{children}</div> : null}
    </div>
  );
};
